import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { driverPay_source } from '../DCR.dtos';
import { accountActionCreators } from '../store/AccountStore';
import { AppState } from '../store/configureStore';
import { Dispatch, bindActionCreators, AnyAction } from 'redux';
import { helperActionCreators } from '../store/HelperStore';
import { connect } from 'react-redux';
import Skeleton from "react-loading-skeleton";
import { DropDown, DropDownOption } from "./DropDown";
import { DisplayBankInfo } from "./DisplayBankInfo";
import { stateNeedsLoading } from '../functions/stateNeedsLoading';
import { getAccountFieldValueByName } from '../functions/dcrGlobal';

export interface PaymentAccountDrowDownProps {
    parentPaymentAccounts?: driverPay_source[];
    onChange?: any;
    defaultValue?: string;
    disabled?: boolean;
    tabIndex?: number;
    className?: string;
}

export type TPaymentAccountDropDwonComponent = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
const PaymentAccountDropDwonComponent = (props: TPaymentAccountDropDwonComponent) => {

    const hasDefault = (props.ownProps.defaultValue && props.ownProps.defaultValue?.trim().length > 0);
    const [selectedValue, setSelectedValue] = useState(hasDefault ? props.ownProps.defaultValue : "");
    const [showDetails, setShowDetails] = useState(false);
    const [loadComponent, setLoadComponent] = useState(false);
    const [paymentAccounts, setPaymentAccounts] = useState<driverPay_source[] | null>(null);
    const [defaultSelected, setDefaultSelected] = useState((selectedValue ?? "").length > 0 ? selectedValue : "");
    const [isAccountsLoaded, setIsAccountsLoaded] = useState(false);

    useEffect(() => {
        if (stateNeedsLoading(props.accounts)) {
            props.fetchBankInfo(props.dcr?.selectedInstitution);
        }
        else if (props.accounts.isLoaded && paymentAccounts === null) {
            setPaymentAccounts(props.accounts.cmAccounts?.pay_sources);
            if (props.accounts.cmAccounts?.pay_sources?.length === 1) {
                setDefaultSelected((props.accounts.cmAccounts?.pay_sources[0]?.sequence).toString());
                setSelectedValue((props.accounts.cmAccounts?.pay_sources[0]?.sequence).toString());
                setShowDetails(true);
            }
            else if (!hasDefault) {
                setDefaultSelected("-1");
            }
            setIsAccountsLoaded(true);
        }
    })

    useEffect(() => {
        if (props.accounts.isLoaded && paymentAccounts === null) {
            setPaymentAccounts(props.accounts.cmAccounts?.pay_sources);
            //changes for schedule cancel payment
            if (props.accounts.cmAccounts?.pay_sources?.length === 1) {
                setDefaultSelected((props.accounts.cmAccounts?.pay_sources[0]?.sequence).toString());
                setSelectedValue((props.accounts.cmAccounts?.pay_sources[0]?.sequence).toString());
                setShowDetails(true);
            }
            else if (!hasDefault) {
                setDefaultSelected("-1");
            }
            setIsAccountsLoaded(true);
        }
    }, [props.accounts.isLoaded])
        

    const getDDLOptions = (): (DropDownOption)[] => {
        const ddlOptions: (DropDownOption)[] = [];
        ddlOptions.push({ value: "-1", display: "Select an account" });
        // eslint-disable-next-line
        paymentAccounts?.map((pymtAcc) =>{
            ddlOptions.push({ value: pymtAcc.sequence?.toString(), display: getAccountFieldValueByName(pymtAcc, "Account Name:~Wespath Account Name:") });

    })

        return ddlOptions;
    }

    const onSelectedChange = (e: { target: { value: React.SetStateAction<string | undefined> } }) => {
        setSelectedValue(e.target.value);
    }

    useEffect(() => {
        if (!loadComponent && isAccountsLoaded && (defaultSelected?.length ?? "") > 0) {
            setLoadComponent(true);
        }
    }, [defaultSelected, isAccountsLoaded])

    useEffect(() => {
        setShowDetails(parseInt(selectedValue ?? "") > 0);
        if (props.ownProps.onChange !== null) {
            props.ownProps.onChange(paymentAccounts?.find(x => (x.sequence === parseInt(selectedValue ?? ""))));
        }
    }, [selectedValue])

    return (
        <>
            {!loadComponent && <LoadingSkeletonPaymentAccountDDL />}

            {loadComponent &&
                <Row>

                    <Col className={props.ownProps?.className ? props.ownProps?.className : "col-12 col-md-6"}>
                        <DropDown name="paymentAccountDDL"
                            dropDownOptions={getDDLOptions()}
                            defaultValue={defaultSelected?.replace(/0/g, "")}
                            disabled={props.ownProps.disabled}
                            tabIndex={props.ownProps.tabIndex}
                            onChange={(e: { target: { value: React.SetStateAction<string | undefined> } }) => { onSelectedChange(e) }}
                            className="paymentDropDownWidth w-75"
                        />
                        <div className="mt-1">
                            {(showDetails && (parseInt(selectedValue ?? "") > 0 || parseInt(defaultSelected ?? "") > 0)) && <>
                                <DisplayBankInfo pmtAccount={paymentAccounts?.find(x => (x.sequence === parseInt(selectedValue ?? "")))} />
                            </>
                            }
                        </div>
                    </Col>
                </Row>
            }
        </>
    )

}

const LoadingSkeletonPaymentAccountDDL = () => (
    <>
        <Row className="my-1 pt-2 d-flex justify-content-center">
            <div><Skeleton width={'33em'} height={'2em'} /></div>
        </Row>
    </>
);

function mapStateToProps(state: AppState, paymentAccountDrowDownProps: PaymentAccountDrowDownProps) {
    return {
        dcr: state.dcr,
        currentUser: state.dcr.currentuserInfo?.user,
        accounts: state.accounts,
        ownProps: paymentAccountDrowDownProps
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({ ...accountActionCreators, ...helperActionCreators }, dispatch);
}

export const PaymentAccountDropDwon = connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentAccountDropDwonComponent);

//export { PaymentAccountDropDwon }